import React from "react";
import { useNavigate } from "react-router-dom";

function HomePage() {
    const navigate = useNavigate();

    return (
        <div className=" mt-16">
            <div className="flex flex-row">
                <div className=" h-[100vh] w-[30%] relative">
                    <div className="absolute bottom-44 left-5 right-5 flex flex-col items-center justify-center gap-5">
                        <div className="font-bold text-4xl text-left">UNLOCK YOUR NEXT LEVEL</div>
                        <div className="text-xxl text-left">The ultimat workout gear—lined with infrared tech to sharpen your edge.</div>
                        <div className="w-full">
                            <button 
                                onClick={() => {
                                    navigate('/products')
                                }}
                                type="click" className=" bg-zinc-900 text-white w-full py-2 rounded-xl hover:bg-slate-700">
                                Shop Now
                            </button>
                        </div>
                    </div>
                </div>
                <div className="h-[100vh] w-[70%] relative">
                    <img
                        className="h-[100vh] w-auto absolute py-2 pl-1"
                        src="https://images.unsplash.com/photo-1618355281911-84e6ec751d84?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=387&q=80"
                        alt=""
                    />
                    <img
                        className="absolute right-0 top-20 h-[80%] w-[70%] object-cover object-center"
                        src="https://images.unsplash.com/photo-1541534741688-6078c6bfb5c5?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=869&q=80"
                        alt=""
                    />
                </div>
            </div>
            <div className="h-[100vh] flex flex-col items-center justify-center gap-20">
                <div className="font-bold text-4xl">Give Them Our Latest & Greatest</div>
                <div className="flex flex-row gap-10 items-center justify-center">
                    <div>
                        <img
                            className=" w-[15rem] h-[15rem] object-cover object-center"
                            src="https://images.unsplash.com/photo-1581009146145-b5ef050c2e1e?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8M3x8bWFuJTIwd29ya291dHxlbnwwfHwwfHw%3D&auto=format&fit=crop&w=2000&q=60"
                            alt=""
                        />
                        <div className="text-left font-bold mt-2 text-sm">Shop Men</div>
                    </div>
                    <div>
                        <img
                            className=" w-[15rem] h-[15rem] object-cover object-center"
                            src="https://images.unsplash.com/photo-1606902965551-dce093cda6e7?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=387&q=80"
                            alt=""
                        />
                        <div className="text-left font-bold mt-2 text-sm">Shop Women</div>
                    </div>
                    <div>
                        <img
                            className=" w-[15rem] h-[15rem] object-cover object-center"
                            src="https://images.unsplash.com/photo-1554342321-0776d282ceac?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=387&q=80"
                            alt=""
                        />
                        <div className="text-left font-bold mt-2 text-sm">Shop Kids</div>
                    </div>
                    <div>
                        <img
                            className=" w-[15rem] h-[15rem] object-cover object-center"
                            src="https://images.unsplash.com/photo-1600712662084-e54770a9668e?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=870&q=80"
                            alt=""
                        />
                        <div className="text-left font-bold mt-2 text-sm">Shop Shoes</div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default HomePage;
